import React from "react";
import moment from "moment";
import StatusTag from "../../../../Common/components/StatusTag";
import "./SampleInfoSection.css";

const SampleInfoSection = ({ rowData }) => {
  if (!rowData) return null;

  const onDashboardSince = rowData.on_dashboard_since;
  const qcTimeFormatted = moment(rowData.ml_soft_qc_timestamp).format("MM/DD/YYYY, h:mm:ss a");

  return (
    <div className="MarkSampleQCModal__Section MarkSampleQCModal__GridColumnFull">
      <div className="MarkSampleQCModal__Details MarkSampleQCModal__Details--twoColumns">
        <div className="MarkSampleQCModal__Description">
          <h6>QC:</h6>
          <StatusTag type="QC" result={rowData.ml_soft_qc_result} />
        </div>
        <div className="MarkSampleQCModal__Description">
          <h6>Customer ID:</h6>
          <p>{rowData.customer_id}</p>
        </div>
        <div className="MarkSampleQCModal__Description">
          <h6>QC Time:</h6>
          <p>
            {`${qcTimeFormatted}${onDashboardSince ? ` (${onDashboardSince})` : ""}`}
          </p>
        </div>
        <div className="MarkSampleQCModal__Description">
          <h6>Customer Name:</h6>
          <p>{rowData.company_name}</p>
        </div>
        <div className="MarkSampleQCModal__Description MarkSampleQCModal__GridColumnFull">
          <h6>Sample ID:</h6>
          <p>{rowData.sample_id}</p>
        </div>
      </div>
    </div>
  );
};

export default SampleInfoSection;
